import { render } from "./LastPublicationWrapper.vue?vue&type=template&id=0914ae50"
import script from "./LastPublicationWrapper.vue?vue&type=script&lang=js"
export * from "./LastPublicationWrapper.vue?vue&type=script&lang=js"

import exportComponent from "/proyectos/programas-de-investigacion/scga-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__